export default "__VITE_ASSET__E7l$EWnd__"